import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import { useRootStore } from '@/stores/root';
import { routes as authRoutes, publicRoutes } from '@/router/routes';
import { useToast } from 'vue-toastification';
import { useGettext } from 'vue3-gettext';
import { auth } from '@vp/vue-components';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/PublicLayout.vue'),
    meta: { requresGuest: true },
    children: publicRoutes,
  },
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: { requiresAuth: true },
    children: authRoutes,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const toast = useToast();
  const { $gettext } = useGettext();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresGuest = to.matched.some(record => record.meta.requresGuest);
  const isLoggedIn = auth.useAuthStore().isLoggedIn;

  if (requiresAuth && !isLoggedIn) {
    toast.warning($gettext('Please log in to access this page.'));
    next({ name: 'Login' });
  } else if (requiresGuest && isLoggedIn) {
    toast.info($gettext('You are already logged in.'));
    next('/events'); // Replace with actual home route
  } else {
    next();
  }
});

router.afterEach(to => {
  const rootStore = useRootStore();
  rootStore.SET_CURRENT_ROUTE(to);
});

export default router;
